import { AloftPrice, PairedCostAdjustmentType, isDefined } from '@aloft/toolkit-shared';

import { selectAdjustmentSettings } from '../orderSelectors.ts';
import { selectManualAdjustmentsEntities } from '../propertyDataSelectors/manualAdjustmentsSelectors.ts';

export const getCommentaryTableHelperText = (
  adjSettings: ReturnType<typeof selectAdjustmentSettings>,
  adjType: PairedCostAdjustmentType,
  label?: string,
  manualAdjustmentsEntities?: ReturnType<typeof selectManualAdjustmentsEntities>,
) => {
  const rounding = adjSettings.enableRounding
    ? (adjSettings.rounding[adjType] ?? adjSettings.roundingDefault)
    : undefined;

  const threshold = adjSettings.enableThreshold
    ? (adjSettings.threshold[adjType] ?? adjSettings.thresholdDefault)
    : undefined;

  const hasManualAdjustmentsForType = manualAdjustmentsEntities
    ? Object.values(manualAdjustmentsEntities).filter(
        (entity) => (entity as Record<string, unknown>)[adjType],
      ).length > 0
    : false;

  const roundingText =
    isDefined(rounding) && rounding.unitAmount > 0
      ? `${
          label ? `${label} adjustments` : 'Adjustments'
        } are rounded to the nearest ${AloftPrice.fromUnitAmount(rounding.unitAmount).toString(
          true,
        )}.`
      : undefined;

  const thresholdText =
    isDefined(threshold) && threshold.unitAmount > 0
      ? `${
          label ? `${label} adjustments` : 'Adjustments'
        } are only included if the value is greater than ${AloftPrice.fromUnitAmount(
          threshold.unitAmount,
        ).toString(true)}.`
      : undefined;

  const manualAdjustmentsText = hasManualAdjustmentsForType
    ? '\n* Indicates values that were manually adjusted by the appraiser.'
    : undefined;

  if (!isDefined(roundingText) && !isDefined(thresholdText)) {
    return undefined;
  }

  const roundingAndThresholdText = `${roundingText ?? ''} ${thresholdText ?? ''}`.trim();
  return roundingAndThresholdText + (manualAdjustmentsText ?? '');
};
